import React from 'react'
import PropTypes from 'prop-types'

class Button extends React.Component {
  render() {
    let { value, ...other } = this.props

    return(
      <input
        type="submit"
        value={value}
        disabled={this.context.form.isSubmitting}
        {...other}
      />
    )
  }
}

Button.propTypes = {
  value: PropTypes.string.isRequired
}

Button.contextTypes = {
  form: PropTypes.object.isRequired
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Form/Button/index.js